import * as types from './weaveTypeActionTypes';

const initialState = {
  weaveTypeData: null,
  weaveTypeList: [],
  createWeaveTypeData: null,
  createWeaveTypeError: null,
  updateWeaveTypeData: null,
  updateWeaveTypeError: null,
  deleteWeaveTypeData: null,
  deleteWeaveTypeError: null,
};

export const weaveTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_WEAVETYPE_DATA:
      return {
        ...state,
        weaveTypeData: action.payload || null,
        weaveTypeList: action.payload?.WeaveTypeList || [],
      };
    case types.GET_WEAVETYPE_ERROR:
      return { ...state, weaveTypeData: null, weaveTypeList: [] };

    case types.CREATE_WEAVETYPE_DATA:
      return { ...state, createWeaveTypeData: action.payload, createWeaveTypeError: null };
    case types.CREATE_WEAVETYPE_ERROR:
      return { ...state, createWeaveTypeData: null, createWeaveTypeError: action.payload };

    case types.UPDATE_WEAVETYPE_DATA:
      return { ...state, updateWeaveTypeData: action.payload, updateWeaveTypeError: null };
    case types.UPDATE_WEAVETYPE_ERROR:
      return { ...state, updateWeaveTypeData: null, updateWeaveTypeError: action.payload };

    case types.DELETE_WEAVETYPE_DATA:
      return { ...state, deleteWeaveTypeData: action.payload, deleteWeaveTypeError: null };
    case types.DELETE_WEAVETYPE_ERROR:
      return { ...state, deleteWeaveTypeData: null, deleteWeaveTypeError: action.payload };

    default:
      return state;
  }
};
